import React from "react";
import { FontIcon, Divider } from "material-ui";
import muiThemeable from "material-ui/styles/muiThemeable";
import {
	DrawerVault,
	DrawerGroupItem,
	DrawerListItem
} from "vault-react-components";
import {
	INDEX,
	LOGIN,
	DECLARACION_JURADAS,
	AFILIADOS,
	BOLETAS,
	EMPRESAS,
	HOLIDAYS,
	FIXED_CONTRIBUTIONS,
	USER_CONTROL,
	BI_COMPANY,
	BI_AFFILIATE,
	BI_PROVINCE,
	PAYMENT_METHODS,
	SUPPORT_TICKET
} from "../../config/RoutesConstants";
import {
	ROL_ADMIN,
	ROL_COORDINADOR,
	ROL_OPERADOR_AFFI,
	ROL_OPERADOR_RECAUDA,
	ROL_BI_USER,
	ROL_SUB_ADMIN,
	ROL_SOPORTE
} from "../../common/Constants";
import Home from "material-ui/svg-icons/action/home";
import Face from "material-ui/svg-icons/action/face";
import DateRanger from "material-ui/svg-icons/action/date-range";
import Money from "material-ui/svg-icons/editor/monetization-on";
import Book from "material-ui/svg-icons/action/chrome-reader-mode";
import Description from "material-ui/svg-icons/action/description";
import Timeline from "material-ui/svg-icons/action/timeline";
import Business from "material-ui/svg-icons/communication/business";
import Map from "material-ui/svg-icons/maps/map";
import Settings from "material-ui/svg-icons/action/settings";
import Payment from "material-ui/svg-icons/action/payment";
import QuestionAnswer from "material-ui/svg-icons/action/question-answer";

const Menu = props => {
	const { navDrawerOpen, onTouchTapItems, rol, email, userDrawer } = props;
	const htmlMenu =
		rol === ROL_ADMIN || rol === ROL_SUB_ADMIN
			? menuAdmin(props)
			: rol === ROL_OPERADOR_AFFI
				? menuOperadorAffi(props)
				: rol === ROL_COORDINADOR
					? menuCoordinador(props)
					: rol === ROL_OPERADOR_RECAUDA
						? menuOperadorRecauda(props)
						: rol === ROL_BI_USER
							? menuBiUser(props)
							: rol === ROL_SOPORTE ? menuSupport(props) : menuUser(props);
	return (
		<DrawerVault
			username={userDrawer}
			email={email}
			isOpen={navDrawerOpen}
			onRequestChangeDrawer={onTouchTapItems}
		>
			<DrawerGroupItem
				toLink={INDEX}
				onTouchTap={onTouchTapItems}
				textoItem="Home"
				icon={<Home />}
				innerDivStyle={{ padding: "0px 16px 0px 53px" }}
			/>
			{htmlMenu}
			<Divider />
			<DrawerGroupItem
				toLink={LOGIN}
				onTouchTap={props.logout}
				textoItem="Salir"
				icon={
					<FontIcon
						className="material-icons"
						color={props.muiTheme.secondaryTextColor}
					>
						exit_to_app
					</FontIcon>
				}
				innerDivStyle={{ padding: "0px 16px 0px 53px" }}
			/>
		</DrawerVault>
	);
};

const menuAdmin = props => {
	const { onTouchTapItems } = props;
	return (
		<div>
			<DrawerGroupItem
				toLink={AFILIADOS}
				textoItem="Afiliados"
				icon={<Face />}
				onTouchTap={onTouchTapItems}
				innerDivStyle={{ padding: "0px 16px 0px 53px" }}
			/>

			<DrawerGroupItem
				toLink={DECLARACION_JURADAS}
				textoItem="Declaraciones Juradas"
				icon={<Book />}
				onTouchTap={onTouchTapItems}
				innerDivStyle={{ padding: "0px 16px 0px 53px" }}
			/>
			<DrawerGroupItem
				toLink={BOLETAS}
				textoItem="Boletas de Pago"
				icon={<Description />}
				onTouchTap={onTouchTapItems}
				innerDivStyle={{ padding: "0px 16px 0px 53px" }}
			/>
			<DrawerGroupItem
				toLink={EMPRESAS}
				textoItem="Empresas"
				icon={<Business />}
				onTouchTap={onTouchTapItems}
				innerDivStyle={{ padding: "0px 16px 0px 53px" }}
			/>
			<DrawerGroupItem
				toLink={SUPPORT_TICKET}
				textoItem="Soporte"
				icon={<QuestionAnswer />}
				onTouchTap={onTouchTapItems}
				innerDivStyle={{ padding: "0px 16px 0px 53px" }}
			/>
			<DrawerListItem
				text={"Parametros"}
				icon={<Settings />}
				style={{ padding: "0px 16px 0px 53px" }}
				nestedItems={[
					<DrawerGroupItem
						key={1}
						className="opcion"
						toLink={HOLIDAYS}
						textoItem="Feriados"
						icon={<DateRanger />}
						onTouchTap={onTouchTapItems}
					/>,
					<DrawerGroupItem
						key={2}
						className="opcion"
						toLink={FIXED_CONTRIBUTIONS}
						textoItem="Contribución Fija"
						icon={<Money />}
						onTouchTap={onTouchTapItems}
					/>,
					<DrawerGroupItem
						key={3}
						icon={<Payment />}
						toLink={PAYMENT_METHODS}
						textoItem="Formas de Pago"
						className="opcion"
						onTouchTap={onTouchTapItems}
					/>,
					<DrawerGroupItem
						key={4}
						icon={<Face />}
						toLink={USER_CONTROL}
						textoItem="Usuarios"
						className="opcion"
						onTouchTap={onTouchTapItems}
					/>
				]}
			/>
		</div>
	);
};

const menuOperadorAffi = props => {
	const { onTouchTapItems } = props;
	return (
		<div>
			<DrawerGroupItem
				toLink={AFILIADOS}
				textoItem="Afiliados"
				icon={<Face />}
				onTouchTap={onTouchTapItems}
				innerDivStyle={{ padding: "0px 16px 0px 53px" }}
			/>
			<DrawerGroupItem
				toLink={DECLARACION_JURADAS}
				textoItem="Declaraciones Juradas"
				icon={<Book />}
				onTouchTap={onTouchTapItems}
				innerDivStyle={{ padding: "0px 16px 0px 53px" }}
			/>
			<DrawerGroupItem
				toLink={EMPRESAS}
				textoItem="Empresas"
				icon={<Business />}
				onTouchTap={onTouchTapItems}
				innerDivStyle={{ padding: "0px 16px 0px 53px" }}
			/>
			<DrawerGroupItem
				toLink={SUPPORT_TICKET}
				textoItem="Soporte"
				icon={<QuestionAnswer />}
				onTouchTap={onTouchTapItems}
				innerDivStyle={{ padding: "0px 16px 0px 53px" }}
			/>
		</div>
	);
};
const menuOperadorRecauda = props => {
	const { onTouchTapItems } = props;
	return (
		<div>
			<DrawerGroupItem
				toLink={AFILIADOS}
				textoItem="Afiliados"
				icon={<Face />}
				onTouchTap={onTouchTapItems}
				innerDivStyle={{ padding: "0px 16px 0px 53px" }}
			/>
			<DrawerGroupItem
				toLink={DECLARACION_JURADAS}
				textoItem="Declaraciones Juradas"
				icon={<Book />}
				onTouchTap={onTouchTapItems}
				innerDivStyle={{ padding: "0px 16px 0px 53px" }}
			/>
			<DrawerGroupItem
				toLink={BOLETAS}
				textoItem="Boletas de Pago"
				icon={<Description />}
				onTouchTap={onTouchTapItems}
				innerDivStyle={{ padding: "0px 16px 0px 53px" }}
			/>
			<DrawerGroupItem
				toLink={EMPRESAS}
				textoItem="Empresas"
				icon={<Business />}
				onTouchTap={onTouchTapItems}
				innerDivStyle={{ padding: "0px 16px 0px 53px" }}
			/>
			<DrawerGroupItem
				toLink={SUPPORT_TICKET}
				textoItem="Soporte"
				icon={<QuestionAnswer />}
				onTouchTap={onTouchTapItems}
				innerDivStyle={{ padding: "0px 16px 0px 53px" }}
			/>
		</div>
	);
};

const menuCoordinador = props => {
	const { onTouchTapItems } = props;
	return (
		<div>
			<DrawerGroupItem
				toLink={AFILIADOS}
				textoItem="Afiliados"
				icon={<Face />}
				onTouchTap={onTouchTapItems}
				innerDivStyle={{ padding: "0px 16px 0px 53px" }}
			/>
			<DrawerGroupItem
				toLink={DECLARACION_JURADAS}
				textoItem="Declaraciones Juradas"
				icon={<Book />}
				onTouchTap={onTouchTapItems}
				innerDivStyle={{ padding: "0px 16px 0px 53px" }}
			/>
			<DrawerGroupItem
				toLink={BOLETAS}
				textoItem="Boletas de Pago"
				icon={<Description />}
				onTouchTap={onTouchTapItems}
				innerDivStyle={{ padding: "0px 16px 0px 53px" }}
			/>
			<DrawerGroupItem
				toLink={EMPRESAS}
				textoItem="Empresas"
				icon={<Business />}
				onTouchTap={onTouchTapItems}
				innerDivStyle={{ padding: "0px 16px 0px 53px" }}
			/>
			<DrawerGroupItem
				toLink={SUPPORT_TICKET}
				textoItem="Soporte"
				icon={<QuestionAnswer />}
				onTouchTap={onTouchTapItems}
				innerDivStyle={{ padding: "0px 16px 0px 53px" }}
			/>
		</div>
	);
};
const menuUser = props => {
	const {
		//navDrawerOpen,
		//onRequestChangeDrawer,
		onTouchTapItems
	} = props;
	return (
		<div>
			<DrawerGroupItem
				toLink={DECLARACION_JURADAS}
				textoItem="Declaraciones Juradas"
				icon={<Book />}
				onTouchTap={onTouchTapItems}
				innerDivStyle={{ padding: "0px 16px 0px 53px" }}
			/>
			<DrawerGroupItem
				toLink={BOLETAS}
				textoItem="Boletas de Pago"
				icon={<Description />}
				onTouchTap={onTouchTapItems}
				innerDivStyle={{ padding: "0px 16px 0px 53px" }}
			/>
		</div>
	);
};
const menuBiUser = props => {
	const { onTouchTapItems } = props;
	return (
		<div>
			<div style={{ padding: "0px 0px 0px 0px" }}>
				<DrawerListItem
					text={"Business Intelligence"}
					icon={<Timeline />}
					style={{ padding: "0px 16px 0px 53px" }}
					nestedItems={[
						<DrawerGroupItem
							key={1}
							icon={<Business />}
							toLink={BI_COMPANY}
							textoItem="Empresas"
							className="opcion"
							onTouchTap={onTouchTapItems}
						/>,
						<DrawerGroupItem
							key={2}
							icon={<Face />}
							toLink={BI_AFFILIATE}
							textoItem="Afiliados"
							className="opcion"
							onTouchTap={onTouchTapItems}
						/>,
						<DrawerGroupItem
							key={3}
							icon={<Map />}
							toLink={BI_PROVINCE}
							textoItem="Provincias"
							className="opcion"
							onTouchTap={onTouchTapItems}
						/>
					]}
				/>
			</div>
		</div>
	);
};
const menuSupport = props => {
	const { onTouchTapItems } = props;
	return (
		<div>
			<div style={{ padding: "0px 0px 0px 0px" }}>
				<DrawerGroupItem
					toLink={SUPPORT_TICKET}
					textoItem="Soporte"
					icon={<QuestionAnswer />}
					onTouchTap={onTouchTapItems}
					innerDivStyle={{ padding: "0px 16px 0px 53px" }}
				/>
			</div>
		</div>
	);
};

export default muiThemeable()(Menu);



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js